export default {
    "api": {
        "projectId": "i5ng84ap",
        "dataset": "production"
    }
}